<div class="contact-services">
    <app-service-code *ngFor="let code of codes" [code]="code" [mode]="mode" (action)="codeAction($event)"></app-service-code>
</div>